"use client";

import { BellAlertIcon } from "@heroicons/react/24/outline";
import { useNotificationSetupBannerContext } from "@/contexts/NotificationSetupBannerContext";

export default function NotificationSetupPassiveChip() {
  const banner = useNotificationSetupBannerContext();

  if (!banner?.passiveChipVisible) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={banner.openSheet}
      className="inline-flex max-w-[9.5rem] items-center gap-1 rounded-full border border-primary/30 bg-primary/10 px-2 py-1 text-[10px] font-medium text-primary-700 hover:bg-primary/15 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary sm:max-w-none sm:text-xs"
      aria-label="Finish alert setup"
    >
      <BellAlertIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span className="truncate">Finish alert setup</span>
    </button>
  );
}
